(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[238],{

/***/ 8718:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[handle]",
      function () {
        return __webpack_require__(72130);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 72130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Product; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(52031);
// EXTERNAL MODULE: ../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(35230);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/snippets/icons/DarkCircleCheckmark.jsx
var DarkCircleCheckmark = __webpack_require__(64647);
;// CONCATENATED MODULE: ./src/utilities/YotpoScript.js
var YotpoScript = function() {
    if (true) {
        var e = document.createElement("script");
        e.type = "text/javascript", e.async = true, e.src = "https://staticw2.yotpo.com/lQ4CeYzdw3OtWNNjZlNguLjoyPQUjQ9VCuuFdAnJ/widget.js";
        e.id = "YotpoBaseScript";
        var t = document.getElementsByTagName("script")[0];
        var b = document.getElementById("YotpoBaseScript");
        if (!b) {
            t.parentNode.insertBefore(e, t);
        }
    }
    CheckYotpoInitialized();
};
var CheckYotpoInitialized = function() {
    setTimeout(function() {
        if ( true && window.yotpo) {
            window.yotpoAPI = new Yotpo.API(yotpo);
            yotpoAPI.refreshWidgets();
        } else {
            CheckYotpoInitialized();
        }
    }, 1000);
};

;// CONCATENATED MODULE: ./src/snippets/products/AfterPay.jsx


function AfterPay(param) {
    var price = param.price, variantId = param.variantId, currency = param.currency;
    var ref = (0,react.useState)(false), mounted = ref[0], setMounted = ref[1];
    (0,react.useEffect)(function() {
        var applyAfterPayStyles = function() {
            var afterpayShadow = document.getElementById("after-pay").shadowRoot;
            var style = document.createElement("style");
            style.textContent = "\n        :host {\n          margin: 0;\n        }\n\n        template {\n          font-size: 14px;\n          position: relative;\n          left: -12px;\n          top: 0px;\n          color: transparent;\n\n          background-image: url('/images/info-icon.png');\n          background-size: 100%;\n          width: 16px;\n        }\n\n        .afterpay-paragraph {\n          font-size: 14px;\n          text-align: center;\n          line-height: 10px;\n        }\n\n        .afterpay-logo {\n          margin: 0;\n        }\n\n        .afterpay-logo.brand-afterpay, .afterpay-logo.brand-afterpay svg {\n          width: 90px !important;\n          margin-left: -5px;\n        }\n\n        .afterpay-link {\n          margin-left: 10px;\n          font-size: 0px;\n        }\n\n        .afterpay-link:before {\n          font-size: 14px;\n          outline: none;\n          border-bottom: 1px solid black;\n          padding-bottom: 0px;\n          font-family: Gotham, sans-serif;\n          position: relative;\n          left: -8px;\n        }\n\n        .afterpay-link {\n          outline: none;\n        }\n\n        .afterpay-logo.black-on-mint .afterpay-logo-badge-background {\n          fill: transparent !important;\n        }\n\n        @media only screen and (max-width: 600px) {\n          .afterpay-logo.black-on-mint .afterpay-logo-badge-background {\n            fill: transparent !important;\n          }\n        }\n\n        @media only screen and (max-width: 1024px) {\n          .afterpay-paragraph {\n            font-size: 12px;\n          }\n        }\n      ";
            afterpayShadow.append(style);
        };
        applyAfterPayStyles();
        setMounted(true);
        var checkExist = setInterval(function() {
            if (document.getElementById("after-pay") && document.getElementById("after-pay").shadowRoot) {
                applyAfterPayStyles();
                clearInterval(checkExist);
            }
        }, 100);
    }, [
        variantId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative mt-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("afterpay-placement", {
                "data-locale": "en_US",
                "data-currency": currency || "USD",
                "data-amount": price,
                "data-modal-theme": "white",
                id: "after-pay"
            }),
            !mounted && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-background absolute inset-0 h-full bg-white"
            })
        ]
    });
}
/* harmony default export */ var products_AfterPay = (AfterPay);

// EXTERNAL MODULE: ./src/snippets/products/ProductGallery.jsx
var ProductGallery = __webpack_require__(3052);
// EXTERNAL MODULE: ./src/snippets/products/ProductInformation.jsx + 2 modules
var ProductInformation = __webpack_require__(48173);
// EXTERNAL MODULE: ../node_modules/isomorphic-fetch/fetch-npm-browserify.js
var fetch_npm_browserify = __webpack_require__(84447);
var fetch_npm_browserify_default = /*#__PURE__*/__webpack_require__.n(fetch_npm_browserify);
// EXTERNAL MODULE: ./public/icons/icon-close.svg
var icon_close = __webpack_require__(23278);
// EXTERNAL MODULE: ./public/icons/error-icon.svg
var error_icon = __webpack_require__(48438);
;// CONCATENATED MODULE: ./src/snippets/products/BackInStockModal.jsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}






function BackInStockModal(param) {
    var selectedVariant = param.selectedVariant, product = param.product;
    var ref = (0,react.useState)(""), email = ref[0], setEmail = ref[1];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(""), message = ref2[0], setMessage = ref2[1];
    var ref3 = (0,react.useState)(false), isOpen = ref3[0], setIsOpen = ref3[1];
    var handleClick = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(event) {
            var variant, resp, body, successMessage;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        event.preventDefault();
                        event.stopPropagation();
                        setLoading(true);
                        variant = selectedVariant.legacyResourceId;
                        _ctx.prev = 4;
                        _ctx.next = 7;
                        return fetch_npm_browserify_default()("/api/back-in-stock?email=".concat(email, "&variant=").concat(variant));
                    case 7:
                        resp = _ctx.sent;
                        _ctx.next = 10;
                        return resp.json();
                    case 10:
                        body = _ctx.sent;
                        if (body === null || body === void 0 ? void 0 : body.ok) {
                            successMessage = "Success! We\u2019ll notify you when this product is in stock. We don\u2019t share your address with anybody else.";
                            setMessage(successMessage);
                            setEmail("");
                        } else {
                            setMessage((body === null || body === void 0 ? void 0 : body.message) || "Uh something went wrong");
                        }
                        _ctx.next = 18;
                        break;
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](4);
                        console.log(_ctx.t0);
                        setMessage("Uh something went wrong");
                    case 18:
                        setLoading(false);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    14
                ]
            ]);
        }));
        return function handleClick(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var openModal = function() {
        setIsOpen(true);
    };
    var closeModal = function() {
        setEmail("");
        setIsOpen(false);
    };
    (0,react.useEffect)(function() {
        document.addEventListener("backInStockModal:open", openModal);
        return function() {
            document.removeEventListener("backInStockModal:open", openModal);
        };
    });
    if (!selectedVariant) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "BackInStockModal fixed top-0 left-0 z-[100] flex h-full w-full items-center justify-center ".concat(isOpen ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "modal-body relative z-[101] mx-auto max-h-[80%] w-[1200px] max-w-[80%] overflow-y-auto bg-white p-4",
                style: {
                    width: "660px",
                    maxWidth: "90%",
                    textAlign: "center",
                    paddingBottom: "30px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "modal-header w-full text-right",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "backInStockModalClose",
                            onClick: closeModal,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_close/* default */.Z, {})
                        }),
                         true && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "modal-body-content gap-6",
                            style: {
                                textAlign: "center",
                                margin: "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "mb-0 text-center text-h5 font-light md:text-h3",
                                        children: "Email Me When Available"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        style: {
                                            display: "block",
                                            textAlign: "center",
                                            my: 15,
                                            maxWidth: "300px",
                                            margin: "15px auto",
                                            color: "#444444",
                                            fontSize: "14px",
                                            marginBottom: "36px"
                                        },
                                        children: "Register your email address below to receive an email as soon as this becomes available again."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            alignItems: "baseline",
                                            mx: "auto",
                                            maxWidth: "660px",
                                            gridGap: "15px",
                                            display: "grid",
                                            gridTemplateColumns: "1fr"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "email",
                                                value: email,
                                                onChange: function(event) {
                                                    return setEmail(event.target.value);
                                                },
                                                placeholder: "Email Address",
                                                style: {
                                                    border: "1px solid #979797",
                                                    maxWidth: "430px",
                                                    width: "100%",
                                                    margin: "auto",
                                                    padding: "12px 20px",
                                                    outline: "none",
                                                    "::placeholder": {
                                                        color: "#444444"
                                                    }
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                type: "button",
                                                "aria-label": "Submit Back In Stock",
                                                className: "button button--primary mt-5 block flex w-full justify-center",
                                                style: {
                                                    maxWidth: "430px",
                                                    width: "100%",
                                                    margin: "auto"
                                                },
                                                disabled: loading,
                                                onClick: handleClick,
                                                children: "email me when available"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            textAlign: "left",
                                            marginTop: 20,
                                            fontSize: "14px",
                                            paddingBottom: 0,
                                            marginBottom: 0,
                                            maxWidth: "430px",
                                            width: "100%",
                                            margin: "24px auto 0px auto",
                                            display: "grid",
                                            gridTemplateColumns: "auto 1fr",
                                            gridGap: "10px"
                                        },
                                        children: [
                                            (message === null || message === void 0 ? void 0 : message.includes("Success")) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/images/success-icon.png",
                                                style: {
                                                    width: "16px",
                                                    marginTop: "3px"
                                                }
                                            }),
                                            message && !(message === null || message === void 0 ? void 0 : message.includes("Success")) && /*#__PURE__*/ (0,jsx_runtime.jsx)(error_icon/* default */.Z, {
                                                style: {
                                                    marginTop: "3px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                style: {
                                                    color: (message === null || message === void 0 ? void 0 : message.includes("Success")) ? "#218246" : "#e23f3f"
                                                },
                                                children: message
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "modalBackdrop z-103 fixed top-0 left-0 h-full w-full cursor-pointer bg-black ".concat(isOpen ? "pointer-events-auto opacity-50" : "opacity-0"),
                onClick: closeModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "sr-only",
                    children: "Close Quick View"
                })
            })
        ]
    });
}
/* harmony default export */ var products_BackInStockModal = (BackInStockModal);

;// CONCATENATED MODULE: ./src/snippets/products/BuyWithPrime.jsx


function BuyWithPrime(param) {
    var sku = param.sku;
    (0,react.useEffect)(function() {
        if (true) {
            window.bwpCartScriptLoadedOn = "";
            var js = window.document.createElement("script");
            js.src = "https://code.buywithprime.amazon.com/bwp.v1.js";
            js.type = "text/javascript";
            js.async = true;
            js.fetchPriority = "high";
            js.id = "bwpScript";
            document.head.appendChild(js);
        }
        return function() {
            // const t = document.getElementById('bwpFrame');
            // t && t.parentNode.removeChild(t);
            var s = document.getElementById("bwpScript");
            s && s.parentNode.removeChild(s);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-prime-widget-sku": sku,
        className: "buy-with-prime-container relative m-auto w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "amzn-buy-now",
                "data-site-id": "gwfxnozf54",
                "data-widget-id": "w-XRZsc7Ov0c7a7UehqIg5N0",
                "data-sku": sku
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "or-separator",
                children: "OR"
            })
        ]
    });
}
/* harmony default export */ var products_BuyWithPrime = (BuyWithPrime);

;// CONCATENATED MODULE: ./src/snippets/products/BuyWithPrimeReviews.jsx


function BuyWithPrimeReviews(param) {
    var sku = param.sku;
    var container = (0,react.useRef)();
    var isBrowser = "object" !== "undefined";
    var header = isBrowser ? document.querySelector("header") : 0;
    var observerConfig = {
        subtree: true,
        childList: true
    };
    var observerCallback = function(mutationList) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // eslint-disable-next-line no-restricted-syntax
            for(var _iterator = mutationList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var mutation = _step.value;
                if (mutation.type === "childList") {
                    // Looks for the iframe added by the Amazon script
                    var iframe = container.current.querySelector("iframe");
                    if (iframe) {
                        // Adds header height + 10 px to the scroll margin so the content doesn't
                        // get overlapped by the floating header
                        iframe.style.scrollMarginTop = "".concat(header.offsetHeight + 10, "px");
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    var observer = isBrowser ? new MutationObserver(observerCallback) : null;
    (0,react.useEffect)(function() {
        if (isBrowser) observer === null || observer === void 0 ? void 0 : observer.observe(container.current, observerConfig);
        return function() {
            if (isBrowser) observer === null || observer === void 0 ? void 0 : observer.disconnect();
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-prime-reviews-sku": sku,
        className: "buy-with-prime-reviews-container relative m-auto w-full",
        ref: container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: "amzn-roa-reviews",
            "data-site-id": "gwfxnozf54",
            "data-roa-instance-id": "w23suqokp7ni1",
            "data-sku": sku
        })
    });
}
/* harmony default export */ var products_BuyWithPrimeReviews = (BuyWithPrimeReviews);

;// CONCATENATED MODULE: ./src/snippets/products/BuyWithPrimeReviewsBadge.jsx

function BuyWithPrimeReviewsBadge(param) {
    var sku = param.sku;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "buy-with-prime-ratings-container relative m-auto w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: "amzn-roa-rating",
            "data-site-id": "gwfxnozf54",
            "data-roa-instance-id": "w23suqokp7ni1",
            "data-sku": sku
        })
    });
}
/* harmony default export */ var products_BuyWithPrimeReviewsBadge = (BuyWithPrimeReviewsBadge);

// EXTERNAL MODULE: ./src/utilities/Metafields.js
var Metafields = __webpack_require__(86501);
// EXTERNAL MODULE: ./src/snippets/icons/ArrowUp.jsx
var ArrowUp = __webpack_require__(90107);
;// CONCATENATED MODULE: ./src/snippets/components/BackToTop.jsx



function BackToTop(param) {
    var scrollReference = param.scrollReference;
    var ref = (0,react.useState)(0), scrollPosition = ref[0], setScrollPosition = ref[1];
    var ref1 = (0,react.useState)(false), enableButton = ref1[0], setEnableButton = ref1[1];
    var updateScrollPosition = function(e) {
        setScrollPosition(window.scrollY);
    };
    var scrollTop = function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", updateScrollPosition);
        return function() {
            window.removeEventListener("scroll", updateScrollPosition);
        };
    }, []);
    (0,react.useEffect)(function() {
        setEnableButton(scrollPosition >= scrollReference.current.clientHeight);
    }, [
        scrollPosition
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fixed right-5 ".concat(enableButton ? "pointer-events-all top-52 opacity-100" : "pointer-events-none top-12  opacity-0", " z-10 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full border border-black bg-black transition-all duration-300 ease-in-out"),
        onClick: scrollTop,
        "aria-hidden": true,
        tabIndex: "-1",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUp/* ArrowUp */.a, {
            className: "text-white"
        })
    });
};

;// CONCATENATED MODULE: ./src/snippets/products/ProductSticky.jsx



function ProductSticky(param) {
    var scrollReference = param.scrollReference, product = param.product, variantPrice = param.variantPrice, comparePrice = param.comparePrice;
    var ref = (0,react.useState)(0), scrollPosition = ref[0], setScrollPosition = ref[1];
    var ref1 = (0,react.useState)(false), enableButton = ref1[0], setEnableButton = ref1[1];
    var buttonRef = (0,react.useRef)(null);
    var metafieldMap = (0,react.useMemo)(function() {
        return (0,Metafields/* getMetafieldMap */.x)(product);
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var ingredient = metafieldMap.custom_ingredient_title;
    var productTitle = metafieldMap.custom_product_title || product.title;
    var firstMedia = product === null || product === void 0 ? void 0 : product.media.find(function(media) {
        var image = null;
        if ((media === null || media === void 0 ? void 0 : media.mediaContentType) === "IMAGE") {
            image = media;
        }
        return image;
    });
    var updateScrollPosition = function() {
        setScrollPosition(window.scrollY);
    };
    var scrollTop = function() {
        buttonRef.current.blur();
        window.scrollTo({
            top: scrollReference.current.offsetTop - 100,
            behavior: "smooth"
        });
    };
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", updateScrollPosition);
        return function() {
            window.removeEventListener("scroll", updateScrollPosition);
        };
    }, []);
    (0,react.useEffect)(function() {
        setEnableButton(scrollPosition >= scrollReference.current.offsetTop + scrollReference.current.clientHeight);
    }, [
        scrollPosition
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "fixed top-[93px] left-0 right-0 z-10 flex w-full transform justify-between border-b border-grey-7 bg-white px-2 py-2 transition-all duration-300 ease-in-out lg:top-[82px] lg:px-12 ".concat(enableButton ? "pointer-events-auto translate-y-0 opacity-100" : "pointer-events-none -translate-y-full opacity-0"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-2 pr-3 lg:pr-0",
                children: [
                    firstMedia && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden h-16 w-16 lg:block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "responsive-image pb-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: firstMedia.image.src,
                                alt: firstMedia.image.altText
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            ingredient && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mb-0 hidden font-tiempos text-h6-m italic text-grey-1 lg:block",
                                children: ingredient
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mb-0 font-tiempos text-sm md:text-h5",
                                children: productTitle
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-3 lg:gap-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-1",
                        children: [
                            comparePrice && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "m-0 font-gothamBold text-xs text-grey-3 line-through lg:text-h6-m",
                                children: comparePrice
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "m-0 font-gothamBold text-xs text-grey-1 lg:text-h6-m",
                                children: variantPrice
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: "button button--checkout min-w-[90px] md:min-w-[160px] lg:min-w-[260px]",
                        onClick: scrollTop,
                        ref: buttonRef,
                        children: "buy"
                    })
                ]
            })
        ]
    });
};
ProductSticky.displayName = "ProductSticky";

// EXTERNAL MODULE: ./src/hooks/index.js + 12 modules
var hooks = __webpack_require__(9148);
// EXTERNAL MODULE: ../node_modules/klaviyo-subscribe/dist/klaviyo-subscribe.es.js
var klaviyo_subscribe_es = __webpack_require__(48129);
;// CONCATENATED MODULE: ./src/snippets/globals/layout/ProductEmailSignup.jsx
function ProductEmailSignup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ProductEmailSignup_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ProductEmailSignup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ProductEmailSignup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





var validateEmail = function(email) {
    return String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
};
function ProductEmailSignup() {
    var ref;
    var ref1 = (0,react.useState)(""), email = ref1[0], setEmail = ref1[1];
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var ref3 = (0,react.useState)(""), message = ref3[0], setMessage = ref3[1];
    var settings = (0,dist.useSettings)();
    var emailSettings = settings === null || settings === void 0 ? void 0 : (ref = settings.product) === null || ref === void 0 ? void 0 : ref.productEmail;
    var listId = (emailSettings === null || emailSettings === void 0 ? void 0 : emailSettings.listId) || "HQmQ53";
    var handleSubmit = (0,react.useCallback)(function() {
        var _ref = ProductEmailSignup_asyncToGenerator(runtime_default().mark(function _callee(e) {
            var isEmailValid;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        if (!isLoading) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        if (email) {
                            _ctx.next = 7;
                            break;
                        }
                        setMessage("Email is required");
                        setTimeout(function() {
                            setMessage("");
                        }, 3000);
                        return _ctx.abrupt("return");
                    case 7:
                        isEmailValid = validateEmail(email);
                        if (isEmailValid) {
                            _ctx.next = 12;
                            break;
                        }
                        setMessage("Email is invalid");
                        setTimeout(function() {
                            setMessage("");
                        }, 3000);
                        return _ctx.abrupt("return");
                    case 12:
                        setIsLoading(true);
                        _ctx.next = 15;
                        return (0,klaviyo_subscribe_es/* subscribe */.L)(listId, email).then(function(param) {
                            var data = param.data;
                            var is_subscribed = data.is_subscribed;
                            if (typeof is_subscribed === "boolean") {
                                setIsLoading(false);
                                setMessage(!is_subscribed ? (emailSettings === null || emailSettings === void 0 ? void 0 : emailSettings.successMessage) || "Email submitted!" : (emailSettings === null || emailSettings === void 0 ? void 0 : emailSettings.submittedMessage) || "Already subscribed!");
                                PubSub.publish("SUBSCRIBE_EMAIL", email);
                                setEmail("");
                                setTimeout(function() {
                                    setMessage("");
                                }, 4000);
                            } else {
                                setIsLoading(false);
                                setEmail("");
                                setMessage("Please try again later");
                            }
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }(), [
        email,
        isLoading,
        message
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            (emailSettings === null || emailSettings === void 0 ? void 0 : emailSettings.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-4 mb-2 font-gothamBold text-left",
                children: emailSettings === null || emailSettings === void 0 ? void 0 : emailSettings.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-4 flex items-center justify-between bg-white border-grey-5 border-[1px] p-1 pr-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-input relative flex w-[20.625rem] flex-col self-start",
                        style: {
                            marginBottom: message ? "1.75rem" : "0"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                name: "email-address",
                                id: "email-address",
                                type: "email",
                                value: email,
                                placeholder: "Email Address",
                                required: true,
                                style: {
                                    outline: "none"
                                },
                                className: "w-full cursor-pointer border-0 border-black bg-transparent py-2 px-4 text-grey-3 placeholder-grey-3 transition-all placeholder-shown:border-grey-7 placeholder-shown:text-grey-3 hover:border-black hover:text-black hover:placeholder-black focus:rounded-none focus:text-black focus:placeholder-black focus:outline-ada-outline",
                                onChange: function(e) {
                                    return setEmail(e.target.value);
                                }
                            }),
                            message && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-xsmall absolute top-[calc(100%+0.5rem)] w-full px-4 text-black",
                                children: message
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        "aria-label": "submit",
                        className: "min-w-[auto] text-center border-button-primary-bg bg-button-primary-bg text-white hover:bg-button-primary-bg-hover hover:border-button-primary-bg-hover button--small lowercase",
                        style: message ? {
                            marginBottom: "auto",
                            marginTop: "5px"
                        } : {},
                        onClick: handleSubmit,
                        children: (emailSettings === null || emailSettings === void 0 ? void 0 : emailSettings.buttonText) || "Submit"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var layout_ProductEmailSignup = (ProductEmailSignup);

;// CONCATENATED MODULE: ./src/templates/product.jsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function product_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function product_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                product_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                product_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


















function ProductTemplate(param) {
    var renderSections = param.renderSections, product = param.product;
    var ref58, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50, ref51;
    var settings = (0,dist.useSettings)();
    var sendViewProductEvent = (0,hooks/* useDataLayerActions */.KZ)().sendViewProductEvent;
    var country = (0,dist.useCountry)().country;
    var countryCode = (country === null || country === void 0 ? void 0 : country.isoCode) || "US";
    var isUs = countryCode === "US";
    var cartAddItem = (0,dist.useCartAddItem)().cartAddItem;
    var variant1 = useGetInitialVariant(product);
    var _ref = (0,dist.useProductInventoryByHandle)({
        handle: product.handle
    }), inventory = _ref.inventory, inventoryStatus = _objectWithoutProperties(_ref, [
        "inventory"
    ]);
    var metafieldMap = (0,react.useMemo)(function() {
        return (0,Metafields/* getMetafieldMap */.x)(product);
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var ref52 = (0,dist.useLocalizedVariant)({
        variant: variant1
    }), localizedVariant = ref52.localized;
    var selectedVariant = _objectSpread({}, variant1, localizedVariant);
    var ref53 = (0,react.useState)(null), selectedPlanId = ref53[0], setSelectedPlanId = ref53[1];
    var firstUpsellProduct = metafieldMap.product_upsell_1;
    var buyboxRef = (0,react.useRef)(null);
    var productInfoRef = (0,react.useRef)(null);
    var isComingSoon = metafieldMap.coming_soon;
    var router = (0,dist.useRouter)();
    if (typeof history !== "undefined" && typeof history.scrollRestoration !== "undefined") {
        history.scrollRestoration = "manual";
    }
    var selectedPlan = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref58 = selectedVariant.sellingPlanAllocations) === null || ref58 === void 0 ? void 0 : ref58.find(function(plan) {
        return (plan === null || plan === void 0 ? void 0 : plan.sellingPlan.id) === selectedPlanId;
    });
    var firstPlan = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref1 = selectedVariant.sellingPlanAllocations) === null || ref1 === void 0 ? void 0 : ref1[0];
    var planAmount = parseFloat((selectedPlan === null || selectedPlan === void 0 ? void 0 : (ref2 = selectedPlan.priceAdjustments) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.price) === null || ref4 === void 0 ? void 0 : ref4.amount) || (firstPlan === null || firstPlan === void 0 ? void 0 : (ref5 = firstPlan.priceAdjustments) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.price) === null || ref7 === void 0 ? void 0 : ref7.amount));
    var variantAmount = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref8 = selectedVariant.priceV2) === null || ref8 === void 0 ? void 0 : ref8.amount;
    var compareAmount = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref9 = selectedVariant.compareAtPriceV2) === null || ref9 === void 0 ? void 0 : ref9.amount;
    var isLocalized = !!(selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref10 = selectedVariant.priceV2) === null || ref10 === void 0 ? void 0 : ref10.locale);
    var currencySymbol = isLocalized ? (country === null || country === void 0 ? void 0 : (ref11 = country.currency) === null || ref11 === void 0 ? void 0 : ref11.symbol) || "$" : "$";
    var currencyCode = (selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref12 = selectedVariant.priceV2) === null || ref12 === void 0 ? void 0 : ref12.currencyCode) || "USD";
    var sellingPlanPrice = planAmount ? "".concat(currencySymbol).concat(planAmount.toFixed(2)).replace(".00", "") : null;
    var comparePrice = compareAmount ? "".concat(currencySymbol).concat(compareAmount).replace(".00", "") : null;
    var variantPrice = "".concat(currencySymbol).concat(variantAmount).replace(".00", "");
    var planOptions = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref13 = selectedVariant.sellingPlanAllocations) === null || ref13 === void 0 ? void 0 : ref13.map(function(plan) {
        var ref, ref55, ref56, ref57;
        return {
            label: plan === null || plan === void 0 ? void 0 : (ref = plan.sellingPlan) === null || ref === void 0 ? void 0 : (ref55 = ref.options) === null || ref55 === void 0 ? void 0 : (ref56 = ref55[0]) === null || ref56 === void 0 ? void 0 : ref56.value,
            value: plan === null || plan === void 0 ? void 0 : (ref57 = plan.sellingPlan) === null || ref57 === void 0 ? void 0 : ref57.id
        };
    });
    (0,react.useEffect)(function() {
        var ref;
        if (!selectedVariant) return;
        var search = window.location.search;
        var searchParams = new URLSearchParams(search);
        var planId = searchParams.get("selling_plan");
        var defaultSubscription = searchParams.has("subscription");
        var activePlan = (ref = selectedVariant.sellingPlanAllocations) === null || ref === void 0 ? void 0 : ref.find(function(plan) {
            return plan.sellingPlan.id.includes(planId);
        });
        if (!activePlan && defaultSubscription) {
            var ref59, ref60;
            activePlan = (ref59 = selectedVariant.sellingPlanAllocations) === null || ref59 === void 0 ? void 0 : ref59[0].sellingPlan;
            planId = (ref60 = selectedVariant.sellingPlanAllocations) === null || ref60 === void 0 ? void 0 : ref60[0].sellingPlan.id;
            delete router.query.subscription;
            router.replace({
                pathname: router.pathname,
                query: _objectSpread({}, router.query)
            }, undefined, {
                shallow: true
            });
        }
        if (activePlan) {
            setSelectedPlanId(planId);
        }
    }, [
        selectedVariant
    ]);
    var ref54 = (0,react.useMemo)(function() {
        var _sections = renderSections();
        if (!_sections) return [
            null,
            []
        ];
        var productSizesSection = _sections.filter(function(s) {
            return s.props["data-comp"] === "productsizes";
        });
        var productUpsellsSection = _sections.filter(function(s) {
            return s.props["data-comp"] === "productupsells";
        });
        var otherSections = _sections.filter(function(s) {
            return ![
                "productsizes"
            ].includes(s.props["data-comp"]);
        });
        return [
            productSizesSection,
            productUpsellsSection,
            otherSections
        ];
    }, [
        renderSections
    ]), productsizes = ref54[0], productupsells = ref54[1], sections = ref54[2];
    var tracksInventory = product === null || product === void 0 ? void 0 : product.tracksInventory;
    var hasInventory = !tracksInventory || ((inventory === null || inventory === void 0 ? void 0 : inventory.totalInventory) || 0) > 0;
    var toggleBackInStockModal = function(e) {
        e.preventDefault();
        document.dispatchEvent(new CustomEvent("backInStockModal:open"));
    };
    var variantIsAvailable = (inventory === null || inventory === void 0 ? void 0 : (ref14 = inventory.variants) === null || ref14 === void 0 ? void 0 : (ref15 = ref14[selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id]) === null || ref15 === void 0 ? void 0 : ref15.availableForSale) && hasInventory || !tracksInventory;
    var jsonSchema = {
        "@context": "https://schema.org/",
        "@type": "Product",
        name: product.title,
        image: product.images.map(function(image) {
            return image.src;
        }),
        description: product.description,
        brand: {
            "@type": "Brand",
            name: product.vendor.replace("_", " ")
        },
        offers: product.variants.map(function(variant) {
            return {
                "@type": "Offer",
                url: product.onlineStoreUrl,
                priceCurrency: variant.currencyCode,
                price: variant.price,
                itemCondition: "https://schema.org/NewCondition",
                availability: "https://schema.org/".concat(variant.availableForSale ? "InStock" : "OutOfStock")
            };
        })
    };
    (0,react.useMemo)(function() {
        YotpoScript();
    }, [
        product.id
    ]);
    (0,react.useEffect)(function() {
        if (!variant1) return;
        sendViewProductEvent({
            product: product,
            selectedVariant: variant1
        });
    }, [
        variant1 === null || variant1 === void 0 ? void 0 : (ref16 = variant1.product) === null || ref16 === void 0 ? void 0 : ref16.handle,
        sendViewProductEvent
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-comp": "ProductTemplate",
        id: product === null || product === void 0 ? void 0 : product.legacyResourceId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-main-container flex w-full flex-col lg:container lg:mx-auto lg:flex-row",
                ref: buyboxRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-gallery flex w-full flex-shrink-0 lg:w-7/12 mb-4 lg:mb-0 lg:sticky lg:h-[100%] lg:top-[80px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductGallery/* default */.Z, {
                            product: product
                        }, product.legacyResourceId)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-info-container m-auto w-full lg:m-0 lg:w-5/12",
                        ref: productInfoRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "product-info-inner-container m-auto max-w-[642px] p-6 pt-1 lg:m-0 lg:p-12 lg:pt-6 lg:pr-8 xl:pr-12 lg:pb-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInformation/* default */.Z, {
                                    product: product,
                                    selectedVariant: selectedVariant,
                                    selectedPlan: selectedPlan
                                }),
                                productsizes,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "block w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductOptions, {
                                            product: product,
                                            activeVariant: selectedVariant
                                        }),
                                        variantIsAvailable && country && isUs && (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.sellingPlanAllocations) && (selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref17 = selectedVariant.sellingPlanAllocations) === null || ref17 === void 0 ? void 0 : ref17.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mb-[16px] overflow-hidden border",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    type: "button",
                                                    className: "grid w-full grid-cols-[auto_auto_1fr] border-b px-[12px] py-[15px] md:px-[20px] bg-[#F5F5F5]  ".concat(!selectedPlanId && "bg-[#FFFFFF]"),
                                                    onClick: function() {
                                                        setSelectedPlanId(null);
                                                        window.dataLayer.push({
                                                            "event": "PDP - One time select"
                                                        });
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "relative top-[2px] mr-[10px] flex h-[18px] w-[18px] cursor-pointer rounded-full border md:top-0 md:mr-[12px] md:h-[20px] md:w-[20px]",
                                                            children: !selectedPlanId && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "relative top-[2px] left-[2px] h-[12px] w-[12px] rounded-full bg-grey-1 md:h-[14px] md:w-[14px]"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "mb-0 font-gothamBold text-[14px]",
                                                            children: "One-time purchase"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "ml-auto font-gothamBold text-[14px]",
                                                            children: [
                                                                comparePrice && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "product-original-price mr-2 font-gothamBold text-[14px] text-[#757575] line-through",
                                                                    children: "".concat(comparePrice)
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "".concat(variantPrice)
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat(selectedPlanId ? "bg-[#FFFFFF]" : "bg-[#F5F5F5]"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                            type: "button",
                                                            className: "grid w-full grid-cols-[auto_auto_1fr] px-[12px] py-[15px] md:px-[20px]",
                                                            onClick: function() {
                                                                var ref;
                                                                setSelectedPlanId(firstPlan === null || firstPlan === void 0 ? void 0 : (ref = firstPlan.sellingPlan) === null || ref === void 0 ? void 0 : ref.id);
                                                                window.dataLayer.push({
                                                                    "event": "PDP - Subscribe & Save select"
                                                                });
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "relative top-[2px] mr-[10px] flex h-[18px] w-[18px] cursor-pointer rounded-full border md:top-0 md:mr-[12px] md:h-[20px] md:w-[20px]",
                                                                    children: selectedPlanId && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "relative top-[2px] left-[2px] h-[12px] w-[12px] rounded-full bg-grey-1 md:h-[14px] md:w-[14px]"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                            className: "mb-0 font-gothamBold text-[14px]",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "whitespace-nowrap",
                                                                                    children: "Subscribe & save ".concat((ref19 = firstPlan === null || firstPlan === void 0 ? void 0 : (ref18 = firstPlan.sellingPlan) === null || ref18 === void 0 ? void 0 : ref18.priceAdjustments[0].adjustmentValue) === null || ref19 === void 0 ? void 0 : ref19.adjustmentPercentage, "%")
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "ml-[20px] hidden whitespace-nowrap bg-[#E61A4F] px-[7px] py-[4px] text-[11px] text-white xl:inline",
                                                                                    children: (settings === null || settings === void 0 ? void 0 : (ref20 = settings.subscriptions) === null || ref20 === void 0 ? void 0 : ref20.freeShippingText) || "Free Shipping"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "whitespace-nowrap bg-[#E61A4F] px-[7px] py-[4px] font-gothamBold text-[11px] text-white xl:hidden",
                                                                            children: (settings === null || settings === void 0 ? void 0 : (ref21 = settings.subscriptions) === null || ref21 === void 0 ? void 0 : ref21.freeShippingText) || "Free Shipping"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "ml-auto",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "product-original-price ml-4 font-gothamBold text-[14px] text-[#757575] line-through",
                                                                            children: "".concat((settings === null || settings === void 0 ? void 0 : (ref22 = settings.discountHighlight) === null || ref22 === void 0 ? void 0 : ref22.enableDiscountHighlight) ? comparePrice || variantPrice : variantPrice)
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "ml-2 font-gothamBold text-[14px]",
                                                                            children: "".concat(sellingPlanPrice)
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        selectedPlanId && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "px-[12px] pb-[15px] md:px-[20px]",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "mb-[8px] flex items-end whitespace-nowrap",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "text-[12px] text-black",
                                                                            children: "Ships every:"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "select-wrap-2 relative flex flex-col",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                                                                className: "ml-2 cursor-pointer border-0 border-b bg-transparent px-2 pb-0 pr-4 pt-0 font-gothamBold text-[12px] text-black text-black placeholder-black outline-0 hover:placeholder-black focus:placeholder-black",
                                                                                name: "selling-plan-select",
                                                                                id: "selling-plan-select",
                                                                                value: selectedPlanId,
                                                                                onChange: function(e) {
                                                                                    setSelectedPlanId(e.target.value);
                                                                                },
                                                                                children: planOptions.map(function(option, optionIndex) {
                                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                        value: option.value,
                                                                                        children: option.label
                                                                                    }, "option-selling-plan-select-".concat(optionIndex));
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "mt-[10px] flex items-baseline whitespace-nowrap",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "text-[10px] text-black ",
                                                                        children: (settings === null || settings === void 0 ? void 0 : (ref23 = settings.subscriptions) === null || ref23 === void 0 ? void 0 : ref23.cancelText) || "Cancel anytime + membership perks."
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "block w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "min-h-[48px] lg:min-h-[52px]",
                                            children: [
                                                variantIsAvailable && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    type: "button",
                                                    className: "button button--checkout block flex w-full justify-center md:px-4 md:text-[12px] lg:text-[16px] h-[70px] flex items-center",
                                                    onClick: product_asyncToGenerator(runtime_default().mark(function _callee() {
                                                        var addItem;
                                                        return runtime_default().wrap(function _callee$(_ctx) {
                                                            while(1)switch(_ctx.prev = _ctx.next){
                                                                case 0:
                                                                    _ctx.prev = 0;
                                                                    addItem = selectedPlanId && isUs ? {
                                                                        merchandiseId: selectedVariant.id,
                                                                        sellingPlanId: btoa(selectedPlanId),
                                                                        quantity: 1,
                                                                        attributes: [
                                                                            {
                                                                                key: "_sellingPlan",
                                                                                value: selectedPlanId
                                                                            }, 
                                                                        ]
                                                                    } : {
                                                                        merchandiseId: selectedVariant.id,
                                                                        quantity: 1,
                                                                        attributes: []
                                                                    };
                                                                    if (firstUpsellProduct) {
                                                                        addItem.attributes.push({
                                                                            key: "_upsellProduct",
                                                                            value: firstUpsellProduct
                                                                        });
                                                                    }
                                                                    _ctx.next = 5;
                                                                    return cartAddItem(addItem, function() {
                                                                        window.dispatchEvent(new CustomEvent("openSideCart"));
                                                                        if (selectedPlanId && isUs) {
                                                                            window.dataLayer.push({
                                                                                "event": "PDP - Add_to_cart Subscribe & Save"
                                                                            });
                                                                        } else {
                                                                            window.dataLayer.push({
                                                                                "event": "PDP - Add_to_cart One Time"
                                                                            });
                                                                        }
                                                                    });
                                                                case 5:
                                                                    _ctx.next = 11;
                                                                    break;
                                                                case 7:
                                                                    _ctx.prev = 7;
                                                                    _ctx.t0 = _ctx["catch"](0);
                                                                    console.error(_ctx.t0);
                                                                    alert("Something whent wrong while adding to cart, please try again.");
                                                                case 11:
                                                                case "end":
                                                                    return _ctx.stop();
                                                            }
                                                        }, _callee, null, [
                                                            [
                                                                0,
                                                                7
                                                            ]
                                                        ]);
                                                    })),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "font-gotham",
                                                            children: "add to cart"
                                                        }),
                                                        country && comparePrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "product-original-price ml-4 font-gothamBold line-through",
                                                                    children: comparePrice
                                                                }),
                                                                selectedPlan ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "ml-2 font-gothamBold",
                                                                    children: "".concat(sellingPlanPrice)
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "ml-2 font-gothamBold",
                                                                    children: variantPrice
                                                                })
                                                            ]
                                                        }),
                                                        country && selectedPlan && sellingPlanPrice && !comparePrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "product-original-price ml-4 font-gothamBold line-through",
                                                                    children: variantPrice
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "ml-2 font-gothamBold",
                                                                    children: "".concat(sellingPlanPrice)
                                                                })
                                                            ]
                                                        }),
                                                        country && !comparePrice && !selectedPlan && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "ml-8 font-gothamBold",
                                                            children: variantPrice
                                                        })
                                                    ]
                                                }),
                                                inventoryStatus.success && !variantIsAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: isComingSoon !== "true" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        type: "button",
                                                        disabled: true,
                                                        className: "button button--primary block flex w-full justify-center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "font-gotham",
                                                            children: hasInventory ? "unavailable" : "out of stock"
                                                        })
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "button block flex w-full justify-center border-grey-7 bg-grey-7 text-black",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "font-gotham",
                                                                    children: "Coming Soon"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_ProductEmailSignup, {})
                                                        ]
                                                    })
                                                }),
                                                isComingSoon !== "true" && inventoryStatus.success && !hasInventory && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    type: "button",
                                                    className: "button button--primary mt-5 block flex w-full justify-center",
                                                    onClick: toggleBackInStockModal,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "font-gotham",
                                                        children: "email me when available"
                                                    })
                                                })
                                            ]
                                        }),
                                        country && isUs && inventoryStatus.success && variantIsAvailable && isComingSoon !== "true" && /*#__PURE__*/ (0,jsx_runtime.jsx)(products_AfterPay, {
                                            variantId: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id,
                                            price: variantPrice || 0,
                                            currency: currencyCode
                                        })
                                    ]
                                }),
                                country && isUs && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-8 !hidden md:!flex lg:flex-row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "productValueProp flex w-1/3",
                                            children: [
                                                (settings === null || settings === void 0 ? void 0 : (ref24 = settings.product) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.productValueProps) === null || ref25 === void 0 ? void 0 : ref25.value_icon_1) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "mr-4 lg:mr-2 relative w-[50px] h-[50px]",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: "md:w-[33px] xl:w-[auto]",
                                                        src: settings === null || settings === void 0 ? void 0 : (ref26 = settings.product) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.productValueProps) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.value_icon_1) === null || ref28 === void 0 ? void 0 : ref28.src,
                                                        alt: (settings === null || settings === void 0 ? void 0 : (ref29 = settings.product) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.productValueProps) === null || ref30 === void 0 ? void 0 : ref30.value_text_1) || "free shipping on all subscriptions"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-small",
                                                    children: (settings === null || settings === void 0 ? void 0 : (ref31 = settings.product) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.productValueProps) === null || ref32 === void 0 ? void 0 : ref32.value_text_1) || "free shipping on all subscriptions"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "productValueProp flex lg:ml-2 w-1/3",
                                            children: [
                                                (settings === null || settings === void 0 ? void 0 : (ref33 = settings.product) === null || ref33 === void 0 ? void 0 : (ref34 = ref33.productValueProps) === null || ref34 === void 0 ? void 0 : ref34.value_icon_2) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "mr-4 lg:mr-2 xl:mr-0 relative w-[50px] h-[50px]",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: "md:w-[33px] xl:w-[auto]",
                                                        src: settings === null || settings === void 0 ? void 0 : (ref35 = settings.product) === null || ref35 === void 0 ? void 0 : (ref36 = ref35.productValueProps) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.value_icon_2) === null || ref37 === void 0 ? void 0 : ref37.src,
                                                        alt: (settings === null || settings === void 0 ? void 0 : (ref38 = settings.product) === null || ref38 === void 0 ? void 0 : (ref39 = ref38.productValueProps) === null || ref39 === void 0 ? void 0 : ref39.value_text_2) || "no hassle 30-day returns"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-small",
                                                    children: (settings === null || settings === void 0 ? void 0 : (ref40 = settings.product) === null || ref40 === void 0 ? void 0 : (ref41 = ref40.productValueProps) === null || ref41 === void 0 ? void 0 : ref41.value_text_2) || "no hassle 30-day returns"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "productValueProp flex lg:ml-4 w-1/3",
                                            children: [
                                                (settings === null || settings === void 0 ? void 0 : (ref42 = settings.product) === null || ref42 === void 0 ? void 0 : (ref43 = ref42.productValueProps) === null || ref43 === void 0 ? void 0 : ref43.value_icon_3) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "mr-4 lg:mr-2 relative w-[50px] h-[50px]",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: "md:w-[33px] xl:w-[auto]",
                                                        src: settings === null || settings === void 0 ? void 0 : (ref44 = settings.product) === null || ref44 === void 0 ? void 0 : (ref45 = ref44.productValueProps) === null || ref45 === void 0 ? void 0 : (ref46 = ref45.value_icon_3) === null || ref46 === void 0 ? void 0 : ref46.src,
                                                        alt: (settings === null || settings === void 0 ? void 0 : (ref47 = settings.product) === null || ref47 === void 0 ? void 0 : (ref48 = ref47.productValueProps) === null || ref48 === void 0 ? void 0 : ref48.value_text_3) || "rewards with every purchase"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-small",
                                                    children: (settings === null || settings === void 0 ? void 0 : (ref49 = settings.product) === null || ref49 === void 0 ? void 0 : (ref50 = ref49.productValueProps) === null || ref50 === void 0 ? void 0 : ref50.value_text_3) || "rewards with every purchase"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                isUs && /*#__PURE__*/ (0,jsx_runtime.jsx)(products_BuyWithPrime, {
                                    sku: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.sku
                                }, "".concat(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.sku, "-bwp-widget")),
                                isUs && /*#__PURE__*/ (0,jsx_runtime.jsx)(products_BuyWithPrimeReviewsBadge, {
                                    sku: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.sku
                                }, "".concat(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.sku, "-bwp-ratings")),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pdp-buybox-desktop-upsells hidden lg:block",
                                    children: productupsells
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackToTop, {
                scrollReference: buyboxRef
            }),
            sections,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-[44px] mb-[10px] text-center font-tiempos text-h4-m md:mt-[100px] md:mb-[40px] md:text-h4",
                children: "Product Reviews & Questions"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "pdp-yotpo-reviews-widget",
                className: "yotpo yotpo-main-widget !mb-[44px] md:!mb-[80px]",
                "data-product-id": product === null || product === void 0 ? void 0 : product.legacyResourceId,
                "data-price": "$".concat(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.price),
                "data-currency": "USD",
                "data-name": product === null || product === void 0 ? void 0 : product.title,
                "data-url": product === null || product === void 0 ? void 0 : product.url,
                "data-image-url": (ref51 = product === null || product === void 0 ? void 0 : product.images[0]) === null || ref51 === void 0 ? void 0 : ref51.src
            }, product === null || product === void 0 ? void 0 : product.legacyResourceId),
            isUs && /*#__PURE__*/ (0,jsx_runtime.jsx)(products_BuyWithPrimeReviews, {
                sku: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.sku
            }, "".concat(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.sku, "-bwp-reviews")),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(products_BackInStockModal, {
                selectedVariant: selectedVariant,
                product: product
            }),
            inventoryStatus.success && variantIsAvailable && isComingSoon !== "true" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSticky, {
                scrollReference: productInfoRef,
                product: product,
                variantPrice: variantPrice,
                comparePrice: comparePrice
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                className: "product-schema",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(jsonSchema)
                }
            })
        ]
    }, product === null || product === void 0 ? void 0 : product.legacyResourceId);
};
var useGetInitialVariant = function(product) {
    var ref;
    var router = (0,dist.useRouter)();
    if (!product) return null;
    var legacyVariantIdQuery = router.query.variant;
    if (legacyVariantIdQuery) {
        //! Attempt to find whaproduct variant that matches the query param
        var queriedVariant = product.variants.find(function(param) {
            var legacyResourceId = param.legacyResourceId;
            return legacyResourceId === legacyVariantIdQuery;
        });
        if (queriedVariant) {
            return queriedVariant;
        }
        return product.variants[0];
    }
    //! We will find the first avaiable, and set that as the variant
    var firstAvailableVariant = product.variants.find(function(param) {
        var availableForSale = param.availableForSale;
        return availableForSale;
    });
    if (firstAvailableVariant) {
        return firstAvailableVariant;
    }
    if (product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : ref.length) {
        return product.variants[0];
    }
};
function ProductOptions(param) {
    var activeVariant = param.activeVariant, product = param.product;
    var router = (0,dist.useRouter)();
    if (!product || !product.options || product.variants.length <= 1) {
        return null;
    }
    var ref = (0,react.useState)(activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.title.split(" / ").map(function(value) {
        return value.trim();
    })), selectedOptions1 = ref[0], setSelectedOptions = ref[1];
    (0,react.useEffect)(function() {
        if (selectedOptions1) {
            var variantTitle = selectedOptions1.join(" / ");
            var selectedVariant = product.variants.find(function(variant) {
                return variant.title === variantTitle;
            });
            router.push({
                pathname: router.pathname,
                query: _objectSpread({}, router.query, {
                    variant: selectedVariant.legacyResourceId
                })
            }, undefined, {
                shallow: true
            });
        }
        if ( true && window.hasOwnProperty("updateYotpoWidgets")) {
            updateYotpoWidgets();
        }
    }, [
        selectedOptions1
    ]);
    return product.options.map(function(option, nameIndex) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mb-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "text-small mb-1 font-gothamBold text-black",
                    children: [
                        " ",
                        option.name,
                        " "
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto flex w-full",
                    children: option.values.map(function(value, valueIndex) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "w-1/6 border border py-2 px-1 font-gothamBold text-[12px] duration-200 hover:border-black hover:bg-grey-9 hover:text-black lg:text-base xl:text-[14px] ".concat(value === selectedOptions1[nameIndex] ? "border-black bg-grey-9 text-black" : "border-grey-4 text-grey-3"),
                            onClick: function() {
                                setSelectedOptions(function(curr) {
                                    var selectedOptions = _toConsumableArray(curr);
                                    selectedOptions[nameIndex] = value.trim();
                                    return selectedOptions;
                                });
                            },
                            children: value
                        }, valueIndex);
                    })
                })
            ]
        }, nameIndex);
    });
}

// EXTERNAL MODULE: ./src/_components/index.js + 9 modules
var _components = __webpack_require__(86091);
;// CONCATENATED MODULE: ./src/pages/products/[handle].jsx
function _handle_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _handle_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _handle_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _handle_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _handle_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _handle_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _handle_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _handle_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _handle_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _handle_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _handle_arrayLikeToArray(o, minLen);
}

/* eslint-disable import/no-unresolved */ 




function DraftBadge() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        "data-comp": "DraftProductBadge",
        // eslint-disable-next-line react/no-unknown-property
        sx: {
            position: "fixed",
            right: 0,
            top: 175,
            transform: "rotate(-90deg)",
            transformOrigin: "bottom right",
            backgroundColor: "#433d51",
            color: "#FFF",
            px: "20px",
            py: "10px",
            fontSize: "14px",
            letterSpacing: "4px",
            fontWeight: 200
        },
        children: "DRAFT"
    });
}
var __N_SSG = true;
function Product(_param) {
    var isPreview = _param.isPreview, renderSections = _param.renderSections, props = _handle_objectWithoutProperties(_param, [
        "isPreview",
        "renderSections"
    ]);
    var router = (0,next_router.useRouter)();
    var settingProduct = (0,react.useRef)(false);
    var product = props.product;
    var ref = _slicedToArray(dist.store.recoil.useRecoilState(dist.store.state.product), 2), recoilProduct = ref[0], setProduct = ref[1];
    var hasQueryParam = router.asPath.includes("?");
    var nextQueryParamReady = Object.keys(router.query).length > 1;
    var handlesMatch = (product === null || product === void 0 ? void 0 : product.handle) === (recoilProduct === null || recoilProduct === void 0 ? void 0 : recoilProduct.handle);
    (0,react.useEffect)(function() {
        if (!handlesMatch) {
            // load the product onto the recoil state
            settingProduct.current = true;
            setProduct(product);
        } else {
            settingProduct.current = false;
        }
        return function() {
            if (hasQueryParam && !nextQueryParamReady) {
                // if we are processing query params
                return;
            }
            if (!settingProduct.current) {
                // unload the product onto the recoil state
                setProduct(null);
            }
        };
    }, [
        handlesMatch
    ]);
    var productPage = props.page;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_components/* PageErrorBoundary */.bg, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(_components/* PageHead */.yG, {
            page: productPage,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTemplate, _handle_objectSpread({}, props, {
                        product: product,
                        renderSections: renderSections
                    })),
                    (product === null || product === void 0 ? void 0 : product.publishedAt) === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DraftBadge, {}) : null
                ]
            })
        })
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(8718); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);